import React, { useState, useEffect, useRef, useContext , useMemo } from "react";
import "../Assests/Scss/Dashboard.scss";
import axios from "axios";
import Doughnutchart from "./Doughnut";
import StackedChart from "./STackedBar";
import GradeMultilinechart from "./GradeMultiplelinechart";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { Row, Col } from "react-bootstrap";
import {
  AssessmentName,
} from "../../Student/Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import { DownloadGraphImage } from "../../ReusableComponents/CommonFunctions";
import { DownloadGraphButton, ExportXlButton } from "../../ReusableComponents/CommonComponents";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { TabViews } from "../../Student/Reusablecomponents/RegularFunctions";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { InstituteGrades } from "../../ReusableComponents/CommonApis";
const TDashboard = () => {
  const { SetLoad } = useContext(LoadContext);
  const Stackedref = useRef();
  const Mlinedref = useRef();
  const SWPRef = useRef();

  const Filters = JSON.parse(localStorage.getItem("DiFFInput"));
  const PrincipleTeachers = useSelector(
    (state) => state.PrincipalTeacherDashboarData
  );
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);

  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SectionWisePercentageDetail =
    process.env.REACT_APP_API_BASE_URL +
    "/TeachersDashboard/GetSectionWisePerformanceForGrade";

  const [SUbjectWisePerformance, SetSUbjectWisePerformance] = useState();
  const [GetGrade, SetGetGrade] = useState(
     PrincipleTeachers?.Grade || Filters?.Grade
  );
  const [DynamicSections, SetDynamicSections] = useState();
  const [Subjects, SetSubjects] = useState();

  const [SectionSelect, SetSectionSelect] = useState(
    Filters?.Section || PrincipleTeachers?.Section || "A"
  );
  const [LinegraphSubject, SetLinegraphSubject] = useState();

  const Subjectwiseperformace = async () => {

    SetSUbjectWisePerformance();
    SetSubjects();
    await axios
      .get(
        SectionWisePercentageDetail +
        `?SchoolId=${items.schoolId}&ContestCreationId=${SelectDate?.value}&Grade=${GetGrade}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]) {
          SetSUbjectWisePerformance(res.data);
          const StoreSubjects = res.data.map((subject) => subject.subjectName);
          SetSubjects(StoreSubjects);
          SetLinegraphSubject(StoreSubjects[0]);
          const sections = res.data.reduce((acc, current) => {
            Object.keys(current).forEach((key) => {
              if (
                key.includes("_") &&
                !acc.includes(key.split("_")[0].slice(3))
              ) {
                acc.push(key.split("_")[0].slice(3));
              }
            });
            return acc;
          }, []);
          SetDynamicSections(sections);
        } else {
          SetSUbjectWisePerformance(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        setTimeout(() => {
          SetLoad((prev) => !prev);
        }, 9000);

      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (SelectDate?.value > 0 && GetGrade > 0) {
      Subjectwiseperformace();
    }
  }, [SelectDate?.value, GetGrade]);

  const GetColor = (e) => {
    switch (e) {
      case "English":
        return "#3182BD";
      case "Mathematics":
        return "#049F34";
      case "Biology":
        return "#7C60BC";
      case "Bio-Technology":
        return "#FB8500";
        case "Hindi":
          return "#f96393";
          case "Telugu":
          return "#AD46FF";
      default:
        return "#F9A915";
    }
  };
  const NavigateQDiff = (section, SubjectName, Percentage) => {
    if (SectionSelect === section && Percentage > 0) {
      const data = {
        Subject: SubjectName,
        Section: SectionSelect,
        Grade: GetGrade,
        SubjectsList: Subjects,
        SectionsList: DynamicSections.map((item) => `Section ${item}`),
      };
      window.open("/TeacherDashboard/TeacherDifficultyLevel", "_blank");
      localStorage.setItem("DiFFInput", JSON.stringify(data));
    }
  };
  const DownloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(`Subject wise performance ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate}`);

    // Step 1: Add heading (merged row)
    const totalColumns = 2 + DynamicSections.length;
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const headingCell = worksheet.getCell("A1");
    headingCell.value = `Subject wise performance ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate} ${GetGrade > 0 && `- Grade ${GetGrade}${SectionSelect}`}`;
    headingCell.font = { bold: true, size: 16 };
    headingCell.alignment = { vertical: "middle", horizontal: "center" };

    // Step 2: Create header rows , ...Array(DynamicSections.length - 1).fill("")
    const headerRow1 = ["S.No", "Subject", "Section"];
    const headerRow2 = ["", "",];
    DynamicSections.forEach((lvl) => headerRow2.push(lvl.toUpperCase()));

    worksheet.addRow(headerRow1);
    worksheet.addRow(headerRow2);
    [2, 3].forEach((rowNum) => {
      worksheet.getRow(rowNum).eachCell((cell) => {
        cell.font = { bold: true };
      });
    });
    // Step 3: Merge subject headers
    worksheet.mergeCells(2, 1, 3, 1);
    worksheet.mergeCells(2, 2, 3, 2);
    // 2. Dynamically merge subject headers
    let startCol = 3;
    const endCol = startCol + DynamicSections.length - 1;
    worksheet.mergeCells(2, startCol, 2, endCol);
    startCol = endCol + 1;

    // Step 4: Add student data
    SUbjectWisePerformance.map((item, index) => {
      const row = [index + 1, item?.subjectName];
      DynamicSections.forEach((lvl) => {
        const val = item?.[`sec${lvl}_Pert`];
        row.push(val > 0 ? `${val}%` : "-");
      });
      worksheet.addRow(row);
    })
    // Step 5: Center align all cells and add borders
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Step 6: Adjust column widths
    worksheet.columns.forEach((col) => {
      col.width = 10;
    });

    // Step 7: Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Subject wise performance ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate} ${GetGrade > 0 && `- Grade ${GetGrade}${SectionSelect}`}.xlsx`);
  };
  const DownloadGraph = (chartRef, e) => {
    DownloadGraphImage(chartRef, e)
  };
  const [ASSGrade, SetAssGrade] = useState();
  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(items?.instituteId, SelectDate, USYear?.value, items?.userId);
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(Grades?.map((grade) => ({ display: `Grade ${grade}`, value: grade.trim() })));
    SetGetGrade( PrincipleTeachers?.Grade || parseInt(Grades?.[0]) || Filters?.Grade);
  }
  useMemo(() => {
    if (SelectDate) { SetLoad((prev) => !prev); GetAssmentdates(); }
  }, [SelectDate?.value]);
  return (
    <>
      <div className="TDashboard-maindiv TeacherBgImage dflex flexd-column  ">
        <InternetChecking />
        <div className="dflex JSBetween ">
          <div className="MainHeading">
            {AssessmentName(SelectDate?.assessmentType)} - {SelectDate?.examStartDate}
          </div>

          <DropdownValues className="NCLDropdown" options={ASSGrade} selectoption={GetGrade}
            Displayname="Select Grade" onChange={(e) => { SetGetGrade(e.target.value); SetLoad((prev) => !prev); }} />
        </div>
        <div className="container-fluid Card">
          <div className="SubHeading">
            Subject wise performance{" "}
            {GetGrade > 0 && `- Grade ${GetGrade}${SectionSelect}`}
          </div>
          <Row>
            {SUbjectWisePerformance?.[0]?.subjectName ? (
              <>
                <Col className="SWPerformance h-100" >
                  <div className=" dflex JSBetween">
                    <div></div>
                    <DownloadGraphButton Click={() => DownloadGraphImage(SWPRef, `Subject wise performance ${AssessmentName(SelectDate?.assessmentType)} - ${SelectDate?.examStartDate} ${GetGrade > 0 && `- Grade ${GetGrade}${SectionSelect}`}`)} /></div>
                  <Doughnutchart Section={SectionSelect} Subjectdata={SUbjectWisePerformance} Ref={SWPRef} />
                </Col><Col  >
                  <div className=" dflex JSBetween">
                    <div></div>
                    <ExportXlButton Name="Export Excel" Click={() => DownloadExcel()} /></div>
                  <table className="Tgrade-Details w-100 mt-1 ">
                    {SUbjectWisePerformance?.[0] && (
                      <thead>
                        <tr>
                          <th rowSpan="2">S.No</th>
                          <th rowSpan="2">Subject</th>
                          <th colSpan={DynamicSections?.length}>
                            Section{" "}
                          </th>
                        </tr>
                        <tr style={{ cursor: "pointer" }}>
                          {SUbjectWisePerformance?.[0] && (
                            <>
                              {DynamicSections?.map((item, index) => (
                                <>
                                  <th
                                    key={index}
                                    style={
                                      SectionSelect === item
                                        ? { backgroundColor: "#E0EAF6" }
                                        : {}
                                    }
                                    onClick={() => SetSectionSelect(item)}
                                  >
                                    {item}
                                  </th>
                                </>
                              ))}
                            </>
                          )}
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {SUbjectWisePerformance?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td style={{ color: GetColor(item.subjectName) }}>
                            {item.subjectName}
                          </td>
                          {DynamicSections.map((section) => (
                            <td
                              key={section}
                              className={
                                SectionSelect === section &&
                                  item[`sec${section}_Pert`]
                                  ? "SubPercentage"
                                  : ""
                              }
                              onClick={() =>
                                NavigateQDiff(
                                  section,
                                  item.subjectName,
                                  item[`sec${section}_Pert`]
                                )
                              }
                              title={
                                SectionSelect === section &&
                                `Click to view Question wise performance by Difficulty level report.`
                              }
                            >
                              {item[`sec${section}_Pert`]
                                ? item[`sec${section}_Pert`] + "%"
                                : "-"}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </>
            ) : (
              <div style={{ height: "25vh" }} className="ErrorMessage">
                {SUbjectWisePerformance}
              </div>
            )}
            {SUbjectWisePerformance?.[0]?.subjectName && (
              <>
                <span className="mt-3"
                > Click on the <b>"Section name"</b> in the table{" "}
                  <b>Section header</b> to view the performance graph in the
                  respective section{" "}
                </span>
              </>
            )}

          </Row>
        </div>
        <div className="MainHeading dflex mt-2">
          Trends for {AssessmentName(SelectDate?.assessmentType)} {USYear?.display}{" "}
          {GetGrade > 0 && `- Grade ${GetGrade}`}
        </div>

        <TabViews Tabs={Subjects} Selectedtab={LinegraphSubject} onClick={(e) => { SetLinegraphSubject(e); }} />
        <div className="container-fluid">
          <Row className="dflex gap-3">
            <Col className="Card">
              <div className="dflex JSBetween">
                <div className="SubHeading">Difficulty level Wise Average Performance</div>
                <DownloadGraphButton Click={() => DownloadGraphImage(Stackedref, `Difficulty level Wise Average Performance - ${USYear?.display} ${GetGrade > 0 && `- Grade ${GetGrade}`} - ${LinegraphSubject}`)} /></div>
              <StackedChart Ref={Stackedref} SubjectName={LinegraphSubject} Grade={GetGrade} Atype={SelectDate?.assessmentType}/>
            </Col>
            <Col className="Card">
              <div className="dflex JSBetween">
                <div className="SubHeading">Performance</div>
                <DownloadGraphButton Click={() => DownloadGraph(Mlinedref, `Performance - ${USYear?.display} ${GetGrade > 0 && `- Grade ${GetGrade}`} - ${LinegraphSubject}`)} /></div>
              <GradeMultilinechart Ref={Mlinedref}
                SubjectName={LinegraphSubject}
                Year={USYear?.value}
                Grade={GetGrade}
                AssessmentType={SelectDate?.assessmentType}
              />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default TDashboard;